/**
 * 本次交付新增：点击颜色变体后，左侧图库过滤为该颜色对应的图片。
 * 不属于主题原有代码，只在 section.settings.enable_variant_color_gallery_sync 开启时才会被加载
 * （见 snippets/product-media-gallery.liquid）。
 *
 * 识别规则（已跟客户确认，见 DECISIONS.md）：
 *   图片 Alt 文本包含颜色名 → 视为该颜色专属图；不区分大小写、允许多余空格。
 *   Alt 文本不包含任何已知颜色名 → 视为通用图，任何颜色下都一直显示。
 *
 * 挂载时机很关键，这里踩过一次坑：一开始监听的是颜色选项的原生 change 事件（同步触发），
 * 但主题自己的 product-info.js 在选中变体后会发一次 AJAX 请求拿最新变体信息，请求回来后
 * （异步，比 change 事件晚）会调用 media-gallery.js 自带的 setActiveMedia() /
 * sortMediaItems()，把图库重新整个刷成"全部 20 张、只是排序变了"，把我们刚做的过滤覆盖掉。
 * 现在改成订阅主题自己的 FoxTheme.pubsub 的 variantChange 事件——这个事件是
 * product-info.js 在自己的整套更新流程（含 sortMediaItems）跑完之后才发出的，我们的过滤
 * 在它之后执行，就不会再被主题自己的逻辑覆盖，写法参考了主题自己的
 * assets/sticky-atc-bar.js 里订阅同一个事件的方式。
 */
(function () {
  if (window.__customPdpVariantGallerySync) return;
  window.__customPdpVariantGallerySync = true;

  function getColorOptionNames(gallery) {
    var raw = gallery.getAttribute('data-color-option-names') || 'color,colour';
    return raw
      .split(',')
      .map(function (s) {
        return s.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function getFieldsetOptionName(fieldset) {
    var el = fieldset.querySelector('[data-selected-swatch-value]');
    return el ? (el.getAttribute('data-selected-swatch-value') || '').trim() : '';
  }

  function isColorFieldset(fieldset, colorOptionNames) {
    var name = getFieldsetOptionName(fieldset).toLowerCase();
    if (!name) return false;
    if (colorOptionNames.indexOf(name) !== -1) return true;
    return name.indexOf('color') !== -1 || name.indexOf('colour') !== -1 || name.indexOf('颜色') !== -1;
  }

  function getKnownColorsFromFieldset(fieldset) {
    var values = [];
    fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.value) values.push(input.value.trim().toLowerCase());
    });
    fieldset.querySelectorAll('select option').forEach(function (option) {
      if (option.value) values.push(option.value.trim().toLowerCase());
    });
    return values.filter(function (v, i, arr) {
      return v && arr.indexOf(v) === i;
    });
  }

  function findColorFieldset(productInfo, colorOptionNames) {
    var found = null;
    productInfo.querySelectorAll('.product-form__input').forEach(function (fieldset) {
      if (!found && isColorFieldset(fieldset, colorOptionNames)) {
        found = fieldset;
      }
    });
    return found;
  }

  function getCheckedColorValue(fieldset) {
    var checkedInput =
      fieldset.querySelector('input[type="radio"]:checked') || fieldset.querySelector('select option[selected]');
    return checkedInput ? (checkedInput.value || checkedInput.textContent || '').trim() : '';
  }

  function ensureMasterLists(gallery) {
    if (gallery.__colorGalleryMediaAll) return;

    var mediaListEl = gallery.querySelector('[id^="Slider-Gallery"]');
    gallery.__colorGalleryMediaAll = mediaListEl
      ? Array.prototype.slice
          .call(mediaListEl.querySelectorAll('.product__media-item'))
          .sort(function (a, b) {
            return (Number(a.dataset.mediaIndex) || 0) - (Number(b.dataset.mediaIndex) || 0);
          })
      : [];

    var thumbListEl = gallery.querySelector('[id^="Slider-Thumbnails"]');
    gallery.__colorGalleryThumbsAll = thumbListEl
      ? Array.prototype.slice
          .call(thumbListEl.querySelectorAll('.product__thumbs-item'))
          .sort(function (a, b) {
            return (Number(a.dataset.mediaPosition) || 0) - (Number(b.dataset.mediaPosition) || 0);
          })
      : [];
  }

  function matchesColor(altText, targetColorLower, knownColors) {
    if (!altText) return true;
    var altLower = altText.toLowerCase();
    if (altLower.indexOf(targetColorLower) !== -1) return true;
    var taggedForOtherColor = knownColors.some(function (color) {
      return color !== targetColorLower && altLower.indexOf(color) !== -1;
    });
    return !taggedForOtherColor;
  }

  function applyColorFilter(gallery, colorValue, knownColors, featuredMediaId) {
    if (!colorValue) return;
    if (typeof gallery.init === 'function') gallery.init();
    if (typeof gallery.ensureDeferredLoaded === 'function') gallery.ensureDeferredLoaded();

    ensureMasterLists(gallery);

    var targetLower = colorValue.trim().toLowerCase();
    var allMedia = gallery.__colorGalleryMediaAll;
    if (!allMedia || allMedia.length === 0) return;

    var matchedMedia = allMedia.filter(function (item) {
      return matchesColor(item.getAttribute('data-alt'), targetLower, knownColors);
    });
    // 兜底：如果规则算出来一张都不匹配（比如颜色名拼写和 alt 完全对不上），
    // 就全部显示，不能让图库塌陷成空白。
    if (matchedMedia.length === 0) matchedMedia = allMedia;

    // 把当前变体的主图挪到最前面，跟主题原生 setActiveMedia() 的体验保持一致。
    if (featuredMediaId) {
      var featuredIndex = matchedMedia.findIndex(function (item) {
        return item.dataset.mediaId === String(featuredMediaId);
      });
      if (featuredIndex > 0) {
        var featuredItem = matchedMedia.splice(featuredIndex, 1)[0];
        matchedMedia.unshift(featuredItem);
      }
    }

    var mediaListEl = gallery.querySelector('[id^="Slider-Gallery"]');
    if (mediaListEl) {
      mediaListEl.innerHTML = '';
      matchedMedia.forEach(function (item) {
        mediaListEl.appendChild(item);
      });
    }

    // 这是初次进入页面时"过滤了但马上又被复原"这个 bug 的根因修复：
    // 主题自己的 product-info.js 在页面刚连接时也会走一遍它自己的 updateMedia()，
    // 但那一刻 media-gallery 组件通常还没升级完成，所以它改成每 100ms 轮询一次，
    // 直到 media-gallery 可用为止。等它真正跑起来时，我们的颜色过滤往往已经先执行完了——
    // 但它内部的 sortMediaItems() 用的是 gallery.elements.mediaItems 这个数组缓存
    // （在我们过滤之前就已经生成，装的是全部颜色的图），它会拿这份"全量旧缓存"整个
    // 重新铺回 mediaList，把我们刚做的过滤覆盖掉——现象就是"点击颜色能生效，
    // 但一进页面还是显示全部颜色的图"。
    // 解法不是掐时间点去抢跑赢它（时序不可靠），而是让这份缓存本身也更新成过滤后的结果，
    // 这样不管主题的原生逻辑之后还会不会再跑一次，用的都是我们过滤后的正确数据。
    if (gallery.elements) {
      gallery.elements.mediaItems = matchedMedia.slice();
    }

    var matchedIds = {};
    matchedMedia.forEach(function (item) {
      matchedIds[item.dataset.mediaId] = true;
    });

    var allThumbs = gallery.__colorGalleryThumbsAll;
    var thumbListEl = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (thumbListEl && allThumbs && allThumbs.length > 0) {
      var matchedThumbs = allThumbs.filter(function (thumb) {
        return matchedIds[thumb.dataset.target];
      });
      if (matchedThumbs.length === 0) matchedThumbs = allThumbs;
      thumbListEl.innerHTML = '';
      matchedThumbs.forEach(function (thumb) {
        thumbListEl.appendChild(thumb);
      });
    }

    if (gallery.sliderInstance && gallery.sliderInstance.slider) {
      gallery.sliderInstance.slider.update();
      gallery.sliderInstance.slider.slideTo(0, 0, false);
    }
    if (gallery.thumbsInstance && gallery.thumbsInstance.slider) {
      gallery.thumbsInstance.slider.update();
    }
    if (typeof gallery.syncThumbsPosition === 'function') {
      gallery.syncThumbsPosition();
    }
  }

  function syncProductInfo(productInfo, featuredMediaId) {
    var gallery = productInfo.querySelector('media-gallery[data-color-gallery-sync="true"]');
    if (!gallery) return;

    var colorOptionNames = getColorOptionNames(gallery);
    var fieldset = findColorFieldset(productInfo, colorOptionNames);
    if (!fieldset) return;

    var colorValue = getCheckedColorValue(fieldset);
    if (!colorValue) return;

    var knownColors = getKnownColorsFromFieldset(fieldset);
    applyColorFilter(gallery, colorValue, knownColors, featuredMediaId);
  }

  function runInitialSync() {
    document.querySelectorAll('media-gallery[data-color-gallery-sync="true"]').forEach(function (gallery) {
      var productInfo = gallery.closest('product-info');
      if (productInfo) syncProductInfo(productInfo);
    });
  }

  function subscribeVariantChange() {
    if (!window.FoxTheme || !FoxTheme.pubsub || !FoxTheme.pubsub.PUB_SUB_EVENTS) return false;

    FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = event && event.data && event.data.sectionId;
      if (!sectionId) return;

      var productInfo = document.querySelector('product-info[data-section="' + CSS.escape(sectionId) + '"]');
      if (!productInfo) return;

      var variant = event.data.variant;
      var featuredMediaId = variant && variant.featured_media ? variant.featured_media.id : null;
      syncProductInfo(productInfo, featuredMediaId);
    });

    return true;
  }

  if (!subscribeVariantChange()) {
    // FoxTheme 理论上会比这个脚本先加载（见 layout/theme.liquid），这里只是防御性兜底。
    document.addEventListener('DOMContentLoaded', subscribeVariantChange);
  }

  if (window.customElements && typeof customElements.whenDefined === 'function') {
    customElements
      .whenDefined('media-gallery')
      .then(runInitialSync)
      .catch(function () {});
  } else {
    document.addEventListener('DOMContentLoaded', runInitialSync);
  }
})();
